import React from 'react';
import './expansion.scss';

class Expansion extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    static defaultProps = {
        expanded: false,
    }

    open() {
        if (!this.root || !this.box) return;
        this.root.style.height = this.box.getBoundingClientRect().height + 'px';
    }

    close() {
        if (!this.root || !this.box) return;
        var height = this.box.getBoundingClientRect().height;
        this.root.className = '';
        this.root.style.height = height + 'px';
        this.root.getBoundingClientRect();//force browser re-layout
        this.root.style.height = 0;
    }

    componentDidMount() {
        if (this.props.expanded) {
            this.root.style.height = 'auto';
        } else {
            this.root.style.height = 0;
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.expanded != prevProps.expanded) {
            if (this.props.expanded) {
                this.open();
            } else {
                this.close();
            }
        }
    }

    render() {
        const className = 'pubhub-agenda-expansion' + (this.props.className ? (' ' + this.props.className) : '' ) + (this.props.expanded ? ' expansion-open' : ' expansion-close');
        return (
            <div ref={dom => { this.root = dom }} className={className}>
                <div ref={dom => { this.box = dom }} className='pubhub-agenda-expansion-box'>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default Expansion;